import UserLayout from '../../layouts/UserLayout.vue'
import brand from '@/brand'

export default [
  {
    path: '/user',
    component: UserLayout,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        name: 'user.dashboard',
        component: () => import('../../views/user/DashboardView.vue'),
        meta: {
          title: `Môj účet - ${brand.siteName}`
        }
      },
      {
        path: 'orders',
        name: 'user.orders',
        component: () => import('../../views/user/OrdersView.vue'),
        meta: {
          title: `Moje objednávky - ${brand.siteName}`
        }
      },
      {
        path: 'orders/:orderNumber',
        name: 'user.order.detail',
        component: () => import('../../views/user/OrderDetailView.vue'),
        meta: {
          title: `Detail objednávky - ${brand.siteName}`
        }
      },
      {
        path: 'messages/:uuid?',
        name: 'user.messages',
        component: () => import('../../views/user/MessagesView.vue'),
        meta: {
          feature: 'chat',
          title: `Moje správy - ${brand.siteName}`
        }
      },
      {
        path: 'addresses',
        name: 'user.addresses',
        component: () => import('../../views/user/AddressesView.vue'),
        meta: {
          title: `Adresy - ${brand.siteName}`
        }
      },
      {
        path: 'settings',
        name: 'user.settings',
        component: () => import('../../views/user/SettingsView.vue'),
        meta: {
          title: `Nastavenia - ${brand.siteName}`
        }
      },
      {
        path: 'marketing',
        name: 'user.marketing',
        component: () => import('../../views/user/MarketingView.vue'),
        meta: {
          feature: 'telemarketing',
          title: `Marketing - ${brand.siteName}`,
          requiresRole: ['admin', 'salesman']
        }
      },
      {
        path: 'create-order',
        name: 'user.create-order',
        component: () => import('../../views/user/CreateOrderView.vue'),
        meta: {
          title: `Vytvoriť objednávku - ${brand.siteName}`,
          requiresRole: ['admin']
        }
      },
      {
        path: 'rewards',
        name: 'user.rewards',
        component: () => import('../../views/user/RewardsView.vue'),
        meta: {
          feature: 'rewards',
          title: `Odmeny - ${brand.siteName}`
        }
      }
    ]
  }
]
